/**
 * Navigate to the next section in the questionnaire or to financial disclosure if there are no more sections
 * @param sections All available questionnaire sections
 * @param currentSection The current section being viewed
 * @param navigate The navigate function from react-router
 */
export const navigateToNextSection = (
  sections: { id: string; order: number; label: string }[],
  currentSection: { id: string; order: number; label: string },
  navigate: (path: string) => void,
) => {
  const nextSections = sections.filter((s) => s.order > currentSection.order);

  if (!nextSections.length) {
    navigate(`/financial-disclosure`);
    return;
  }

  const nextOrder = Math.min(...nextSections.map((s) => s.order));
  const nextSection = sections.find((s) => s.order === nextOrder);

  if (nextSection) {
    navigate(
      `/questionnaire/${nextSection.label.toLowerCase().replace(/ /g, "-")}`,
    );
  }
};

/**
 * Utility function to scroll to top of the page
 */
export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "instant",
  });
};
